import axios from 'axios';
import { HTTPStatusCodes } from '../constant';

export function is401UnauthorizedError(error: any): boolean {
  return (
    axios.isAxiosError(error) &&
    error.response?.status === HTTPStatusCodes.UNAUTHORIZED
  );
}

export function is409ConflictError(error: any): boolean {
  return (
    axios.isAxiosError(error) &&
    error.response?.status === HTTPStatusCodes.CONFLICT
  );
}

export const handleApiError = (error: unknown) => {
  if (axios.isAxiosError(error) && error.response) {
    return {
      message: error.response.data?.message || error.response.data?.errorMessage || error.message || 'An error occurred',
      status: error.response.status,
    };
  }
  
  return {
    message: error instanceof Error ? error.message : 'An unknown error occurred',
    stack: error instanceof Error ? error.stack : undefined,
  };
};

export const createApiError = (message: string, responseData: any): Error  => {
  const error = new Error(message) as any;
  error.response = {
    data: responseData,
    status: responseData.statusCode,
  };
  error.isApiError = true;
  return error;
}